import AreaServico from '@/portal/dominio/areas/AreaServico.js'
import { Actions, Getters, Mutations } from '../types'

const api = AreaServico.build({})

// Estado inicial
const state = {
    areas: []
}
// getters

const getters = {
    [Getters.AREAS.AREAS_NEGOCIO]: (state) => state.areas,
    [Getters.AREAS.AREA_POR_CODIGO]: (state) => (codigo) => state.areas.find(area => area.codigo === codigo),
    [Getters.AREAS.AREA_POR_CONTEXTO]: (state) => (contexto) => state.areas.find(area => area.contexto === contexto)
}

// actions
const actions = {

    [Actions.AREAS.CARREGAR]: ({ commit }) => {
        return api.listarAreasNegocio()
                .then(areas => {
                    commit(Mutations.AREAS.AREAS_NEGOCIO, areas);
                })
    },

}

// mutations
const mutations = {
    [Mutations.AREAS.AREAS_NEGOCIO]: (state, areas) => {
        areas.forEach(area => {
            let superior = area.areaSuperior
            if(superior){
                let sup = areas.find(a => a.codigo === superior)
                area.areaSuperior = sup;
            }
        });
        state.areas = areas;
    }
   
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}